import React from 'react'

export const CardSkeleton = () => {
  return (
    <div className='lg:grid-cols-3 md:grid-cols-2 grid-cols-1'>
          <div className={`flex flex-col border-[12px] border-white p-6 relative gap-1 `}>
            {/* Placeholder for image */}
            <div className="w-full h-[179px] bg-gray-200 animate-pulse"></div>

            {/* Placeholder for course tag */}
            <div className={` w-1/4 h-4 bg-gray-200 rounded animate-pulse mt-2`}></div>

            {/* Placeholder for card details */}
            <div className="">
                <div className="">
                    {/* Placeholder for timeline and lessons */}
                    <div className={` flex gap-4`}>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                    </div>

                    {/* Placeholder for description */}
                    <div className={` mt-4`}>
                        <div className="w-3/4 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-2"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-1"></div>
                    </div>
                </div>

                {/* Placeholder for instructor details and button */}
                <div className="flex justify-between w-full mt-6">
                    <div className="w-1/2 h-6 bg-gray-200 animate-pulse rounded"></div>
                    <div className="w-28 h-10 bg-gray-200 animate-pulse rounded"></div>
                </div>
            </div>
        </div>
          <div className={`flex flex-col border-[12px] border-white p-6 relative gap-1 `}>
            {/* Placeholder for image */}
            <div className="w-full h-[179px] bg-gray-200 animate-pulse"></div>

            {/* Placeholder for course tag */}
            <div className={` w-1/4 h-4 bg-gray-200 rounded animate-pulse mt-2`}></div>

            {/* Placeholder for card details */}
            <div className="">
                <div className="">
                    {/* Placeholder for timeline and lessons */}
                    <div className={` flex gap-4`}>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                    </div>

                    {/* Placeholder for description */}
                    <div className={` mt-4`}>
                        <div className="w-3/4 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-2"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-1"></div>
                    </div>
                </div>

                {/* Placeholder for instructor details and button */}
                <div className="flex justify-between w-full mt-6">
                    <div className="w-1/2 h-6 bg-gray-200 animate-pulse rounded"></div>
                    <div className="w-28 h-10 bg-gray-200 animate-pulse rounded"></div>
                </div>
            </div>
        </div>
          <div className={`flex flex-col border-[12px] border-white p-6 relative gap-1 `}>
            {/* Placeholder for image */}
            <div className="w-full h-[179px] bg-gray-200 animate-pulse"></div>

            {/* Placeholder for course tag */}
            <div className={` w-1/4 h-4 bg-gray-200 rounded animate-pulse mt-2`}></div>

            {/* Placeholder for card details */}
            <div className="">
                <div className="">
                    {/* Placeholder for timeline and lessons */}
                    <div className={` flex gap-4`}>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                    </div>

                    {/* Placeholder for description */}
                    <div className={` mt-4`}>
                        <div className="w-3/4 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-2"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-1"></div>
                    </div>
                </div>

                {/* Placeholder for instructor details and button */}
                <div className="flex justify-between w-full mt-6">
                    <div className="w-1/2 h-6 bg-gray-200 animate-pulse rounded"></div>
                    <div className="w-28 h-10 bg-gray-200 animate-pulse rounded"></div>
                </div>
            </div>
        </div>
          <div className={`flex flex-col border-[12px] border-white p-6 relative gap-1 `}>
            {/* Placeholder for image */}
            <div className="w-full h-[179px] bg-gray-200 animate-pulse"></div>

            {/* Placeholder for course tag */}
            <div className={` w-1/4 h-4 bg-gray-200 rounded animate-pulse mt-2`}></div>

            {/* Placeholder for card details */}
            <div className="">
                <div className="">
                    {/* Placeholder for timeline and lessons */}
                    <div className={` flex gap-4`}>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                    </div>

                    {/* Placeholder for description */}
                    <div className={` mt-4`}>
                        <div className="w-3/4 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-2"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-1"></div>
                    </div>
                </div>

                {/* Placeholder for instructor details and button */}
                <div className="flex justify-between w-full mt-6">
                    <div className="w-1/2 h-6 bg-gray-200 animate-pulse rounded"></div>
                    <div className="w-28 h-10 bg-gray-200 animate-pulse rounded"></div>
                </div>
            </div>
        </div>
          <div className={`flex flex-col border-[12px] border-white p-6 relative gap-1 `}>
            {/* Placeholder for image */}
            <div className="w-full h-[179px] bg-gray-200 animate-pulse"></div>

            {/* Placeholder for course tag */}
            <div className={` w-1/4 h-4 bg-gray-200 rounded animate-pulse mt-2`}></div>

            {/* Placeholder for card details */}
            <div className="">
                <div className="">
                    {/* Placeholder for timeline and lessons */}
                    <div className={` flex gap-4`}>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                    </div>

                    {/* Placeholder for description */}
                    <div className={` mt-4`}>
                        <div className="w-3/4 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-2"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-1"></div>
                    </div>
                </div>

                {/* Placeholder for instructor details and button */}
                <div className="flex justify-between w-full mt-6">
                    <div className="w-1/2 h-6 bg-gray-200 animate-pulse rounded"></div>
                    <div className="w-28 h-10 bg-gray-200 animate-pulse rounded"></div>
                </div>
            </div>
        </div>
          <div className={`flex flex-col border-[12px] border-white p-6 relative gap-1 `}>
            {/* Placeholder for image */}
            <div className="w-full h-[179px] bg-gray-200 animate-pulse"></div>

            {/* Placeholder for course tag */}
            <div className={` w-1/4 h-4 bg-gray-200 rounded animate-pulse mt-2`}></div>

            {/* Placeholder for card details */}
            <div className="">
                <div className="">
                    {/* Placeholder for timeline and lessons */}
                    <div className={` flex gap-4`}>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                    </div>

                    {/* Placeholder for description */}
                    <div className={` mt-4`}>
                        <div className="w-3/4 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-2"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-1"></div>
                    </div>
                </div>

                {/* Placeholder for instructor details and button */}
                <div className="flex justify-between w-full mt-6">
                    <div className="w-1/2 h-6 bg-gray-200 animate-pulse rounded"></div>
                    <div className="w-28 h-10 bg-gray-200 animate-pulse rounded"></div>
                </div>
            </div>
        </div>
          <div className={`flex flex-col border-[12px] border-white p-6 relative gap-1 `}>
            {/* Placeholder for image */}
            <div className="w-full h-[179px] bg-gray-200 animate-pulse"></div>

            {/* Placeholder for course tag */}
            <div className={` w-1/4 h-4 bg-gray-200 rounded animate-pulse mt-2`}></div>

            {/* Placeholder for card details */}
            <div className="">
                <div className="">
                    {/* Placeholder for timeline and lessons */}
                    <div className={` flex gap-4`}>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                    </div>

                    {/* Placeholder for description */}
                    <div className={` mt-4`}>
                        <div className="w-3/4 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-2"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-1"></div>
                    </div>
                </div>

                {/* Placeholder for instructor details and button */}
                <div className="flex justify-between w-full mt-6">
                    <div className="w-1/2 h-6 bg-gray-200 animate-pulse rounded"></div>
                    <div className="w-28 h-10 bg-gray-200 animate-pulse rounded"></div>
                </div>
            </div>
        </div>
          <div className={`flex flex-col border-[12px] border-white p-6 relative gap-1 `}>
            {/* Placeholder for image */}
            <div className="w-full h-[179px] bg-gray-200 animate-pulse"></div>

            {/* Placeholder for course tag */}
            <div className={` w-1/4 h-4 bg-gray-200 rounded animate-pulse mt-2`}></div>

            {/* Placeholder for card details */}
            <div className="">
                <div className="">
                    {/* Placeholder for timeline and lessons */}
                    <div className={` flex gap-4`}>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                    </div>

                    {/* Placeholder for description */}
                    <div className={` mt-4`}>
                        <div className="w-3/4 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-2"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-1"></div>
                    </div>
                </div>

                {/* Placeholder for instructor details and button */}
                <div className="flex justify-between w-full mt-6">
                    <div className="w-1/2 h-6 bg-gray-200 animate-pulse rounded"></div>
                    <div className="w-28 h-10 bg-gray-200 animate-pulse rounded"></div>
                </div>
            </div>
        </div>
          <div className={`flex flex-col border-[12px] border-white p-6 relative gap-1 `}>
            {/* Placeholder for image */}
            <div className="w-full h-[179px] bg-gray-200 animate-pulse"></div>

            {/* Placeholder for course tag */}
            <div className={` w-1/4 h-4 bg-gray-200 rounded animate-pulse mt-2`}></div>

            {/* Placeholder for card details */}
            <div className="">
                <div className="">
                    {/* Placeholder for timeline and lessons */}
                    <div className={` flex gap-4`}>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                    </div>

                    {/* Placeholder for description */}
                    <div className={` mt-4`}>
                        <div className="w-3/4 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-2"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-1"></div>
                    </div>
                </div>

                {/* Placeholder for instructor details and button */}
                <div className="flex justify-between w-full mt-6">
                    <div className="w-1/2 h-6 bg-gray-200 animate-pulse rounded"></div>
                    <div className="w-28 h-10 bg-gray-200 animate-pulse rounded"></div>
                </div>
            </div>
        </div>
          <div className={`flex flex-col border-[12px] border-white p-6 relative gap-1 `}>
            {/* Placeholder for image */}
            <div className="w-full h-[179px] bg-gray-200 animate-pulse"></div>

            {/* Placeholder for course tag */}
            <div className={` w-1/4 h-4 bg-gray-200 rounded animate-pulse mt-2`}></div>

            {/* Placeholder for card details */}
            <div className="">
                <div className="">
                    {/* Placeholder for timeline and lessons */}
                    <div className={` flex gap-4`}>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                    </div>

                    {/* Placeholder for description */}
                    <div className={` mt-4`}>
                        <div className="w-3/4 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-2"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-1"></div>
                    </div>
                </div>

                {/* Placeholder for instructor details and button */}
                <div className="flex justify-between w-full mt-6">
                    <div className="w-1/2 h-6 bg-gray-200 animate-pulse rounded"></div>
                    <div className="w-28 h-10 bg-gray-200 animate-pulse rounded"></div>
                </div>
            </div>
        </div>
          <div className={`flex flex-col border-[12px] border-white p-6 relative gap-1 `}>
            {/* Placeholder for image */}
            <div className="w-full h-[179px] bg-gray-200 animate-pulse"></div>

            {/* Placeholder for course tag */}
            <div className={` w-1/4 h-4 bg-gray-200 rounded animate-pulse mt-2`}></div>

            {/* Placeholder for card details */}
            <div className="">
                <div className="">
                    {/* Placeholder for timeline and lessons */}
                    <div className={` flex gap-4`}>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                    </div>

                    {/* Placeholder for description */}
                    <div className={` mt-4`}>
                        <div className="w-3/4 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-2"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-1"></div>
                    </div>
                </div>

                {/* Placeholder for instructor details and button */}
                <div className="flex justify-between w-full mt-6">
                    <div className="w-1/2 h-6 bg-gray-200 animate-pulse rounded"></div>
                    <div className="w-28 h-10 bg-gray-200 animate-pulse rounded"></div>
                </div>
            </div>
        </div>
          <div className={`flex flex-col border-[12px] border-white p-6 relative gap-1 `}>
            {/* Placeholder for image */}
            <div className="w-full h-[179px] bg-gray-200 animate-pulse"></div>

            {/* Placeholder for course tag */}
            <div className={` w-1/4 h-4 bg-gray-200 rounded animate-pulse mt-2`}></div>

            {/* Placeholder for card details */}
            <div className="">
                <div className="">
                    {/* Placeholder for timeline and lessons */}
                    <div className={` flex gap-4`}>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-12 h-6 bg-gray-200 animate-pulse rounded"></div>
                    </div>

                    {/* Placeholder for description */}
                    <div className={` mt-4`}>
                        <div className="w-3/4 h-6 bg-gray-200 animate-pulse rounded"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-2"></div>
                        <div className="w-full h-4 bg-gray-200 animate-pulse rounded mt-1"></div>
                    </div>
                </div>

                {/* Placeholder for instructor details and button */}
                <div className="flex justify-between w-full mt-6">
                    <div className="w-1/2 h-6 bg-gray-200 animate-pulse rounded"></div>
                    <div className="w-28 h-10 bg-gray-200 animate-pulse rounded"></div>
                </div>
            </div>
        </div>
    </div>
  )
}
